import { en } from './en'
import { it } from './it'

export type Locale = 'en' | 'it'
export type TranslationKey = keyof typeof en

const DEFAULT_LOCALE: Locale = 'en'

const dictionaries: Record<Locale, Record<TranslationKey, string>> = { en, it }

export function translate(key: TranslationKey, locale?: string): string {
  return dictionaries[resolveLocale(locale)][key]
}

function resolveLocale(locale: string | undefined): Locale {
  const language = locale?.slice(0, 2).toLowerCase()
  return language === 'it' ? 'it' : DEFAULT_LOCALE
}
